<div class="scheduler-page-wrapper" *ngIf="!meetingLinkExpired">
    @if(!bookingComplete){
    <div class="scheduler-header">
        <strong class="scheduler-title">Meeting Scheduler</strong>
    </div>

    <!-- Dynamic rep card -->
    @if (meetingData) {
    <div class="rep-card">
        <div class="rep-info">
            <div class="calendar-icon">
                <span>📅</span>
            </div>
            <div class="rep-details">
                <p class="user-info"><span class="rep-company">{{ meetingData.organizer.name + ' ' +  meetingData.organizer.lastName+' '}}</span> <span *ngIf="meetingData.companyName">({{ meetingData.companyName }})</span> is inviting you to</p>
                <h2 class="rep-name">{{ meetingData.title }} ({{meetingData.duration}} min)</h2>
                @if(meetingData.location || meetingData.calendarType){
                    @if(meetingData.calendarType){
                        <p>It will be a {{ meetingData.calendarType || '' }} Meeting</p>
                    }
                    @if(meetingData.location){
                        <p class="rep-company">Location: {{ meetingData.location || '' }}</p>
                    }
                    
                }
                
                <p class="rep-position">{{ meetingData.description || '' }}</p>
            </div>
        </div>
    </div>
    }

    <div class="meeting-container">
        <div class="date-picker">
            <div class="week-navigation">
                <button class="nav-button" [disabled]="disablePreviousButton" (click)="previousWeek()">
                    <span class="arrow">&#8249;</span> Previous week
                </button>
                <button class="nav-button" [disabled]="disableNextButton" (click)="nextWeek()">
                    Next week <span class="arrow">&#8250;</span>
                </button>
            </div>

            <div class="week-days">
                @for (day of weekDays; track day.dayNumber) {
                <div class="day-item" [class.today]="day.isToday" [class.selected]="day.isSelected"
                    [class.available]="day.hasSlots" [class.unavailable]="!day.hasSlots" (click)="selectDate(day)"
                    [title]="day.hasSlots ? 'Available for booking' : 'No time slots available'">
                    <div class="day-name">{{ day.dayName }}</div>
                    <div class="day-number">{{ day.dayNumber }}</div>
                    <div class="day-month">{{ day.month }}</div>
                </div>
                }
            </div>

            <div class="timezone-display" *ngIf="selectedDate">
                <div class="timezone-info">
                  Times shown in your local time zone - {{userTimezone}} (UTC {{userTimezoneOffset}})
                </div>
              </div>

            @if (selectedDate) {
            <hr />
            <div class="time-selection">
                <h3>Choose time</h3>
                <div class="time-slots">
                    @if (morningSlots.length > 0) {
                    <div class="time-column">
                        <h4 style="text-align: center;">Morning</h4>
                        @for (slot of morningSlots; track slot.id) {
                        <button class="time-slot" [class.selected]="selectedTimeSlot?.id === slot.id"
                            (click)="selectTimeSlot(slot)" id="time-slot-{{slot.id}}">
                            <span class="time-display">{{ slot.formattedTime }}</span>
                            <span class="time-range" [class.visible]="selectedTimeSlot?.id === slot.id">
                                {{ formatTimeOnly(slot.startTime) }} - {{ formatTimeOnly(slot.endTime) }}
                            </span>
                        </button>
                        }
                    </div>
                    }
                    @if (afternoonSlots.length > 0) {
                    <div class="time-column">
                        <h4 style="text-align: center;">Afternoon</h4>
                        @for (slot of afternoonSlots; track slot.id) {
                        <button class="time-slot" [class.selected]="selectedTimeSlot?.id === slot.id"
                            (click)="selectTimeSlot(slot)" id="time-slot-{{slot.id}}">
                            <span class="time-display">{{ slot.formattedTime }}</span>
                            <span class="time-range" [class.visible]="selectedTimeSlot?.id === slot.id">
                                {{ formatTimeOnly(slot.startTime) }} - {{ formatTimeOnly(slot.endTime) }}
                            </span>
                        </button>
                        }
                    </div>
                    }
                </div>
            </div>
            }
        </div>

        @if (showBookingForm) {
        <hr id="booking-form-anchor" />
        <!-- Booking Form with Lead Fields -->
        <div class="booking-form">
            <h2>
                Enter your information
            </h2>

            <form [formGroup]="bookingForm" (ngSubmit)="confirmBooking()">
                <!-- Default fields - shown only when lead creation is NOT enabled -->
                @if (!isLeadCreationEnabled) {
                    @for (field of defaultFields; track field.id) {
                        <div class="form-group">
                            @switch (field.type) {
                                @case ('text') {
                                    <input type="text" 
                                           [formControlName]="field.id" 
                                           [placeholder]="field.label"
                                           [class.invalid]="bookingForm.get(field.id)?.invalid && bookingForm.get(field.id)?.touched">
                                    @if (bookingForm.get(field.id)?.invalid && bookingForm.get(field.id)?.touched) {
                                        <div class="error-message">
                                            @if (bookingForm.get(field.id)?.errors?.['required']) {
                                                <span>{{ field.label }} is required</span>
                                            }
                                        </div>
                                    }
                                }
                                @case ('email') {
                                    <input type="email" 
                                           [formControlName]="field.id" 
                                           [placeholder]="field.label"
                                           [class.invalid]="bookingForm.get(field.id)?.invalid && bookingForm.get(field.id)?.touched">
                                    @if (bookingForm.get(field.id)?.invalid && bookingForm.get(field.id)?.touched) {
                                        <div class="error-message">
                                            @if (bookingForm.get(field.id)?.errors?.['required']) {
                                                <span>{{ field.label }} is required</span>
                                            } @else if (bookingForm.get(field.id)?.errors?.['email']) {
                                                <span>Please enter a valid email address</span>
                                            }
                                        </div>
                                    }
                                }
                                @case ('date') {
                                    <input type="date" 
                                           [formControlName]="field.id" 
                                           [placeholder]="field.label"
                                           [class.invalid]="bookingForm.get(field.id)?.invalid && bookingForm.get(field.id)?.touched">
                                    @if (bookingForm.get(field.id)?.invalid && bookingForm.get(field.id)?.touched) {
                                        <div class="error-message">
                                            @if (bookingForm.get(field.id)?.errors?.['required']) {
                                                <span>{{ field.label }} is required</span>
                                            } @else if (bookingForm.get(field.id)?.errors?.['dateMin']) {
                                                <span>Date must be today or later</span>
                                            } @else if (bookingForm.get(field.id)?.errors?.['dateMax']) {
                                                <span>Date must be before {{ field.maxDate }}</span>
                                            }
                                        </div>
                                    }
                                }
                                @case ('number') {
                                    <input [type]="isGraduationYearField(field) ? 'text' : 'number'"
                                           [formControlName]="field.id" 
                                           [placeholder]="field.label"
                                           [attr.min]="isGraduationYearField(field) ? null : getFieldMin(field)"
                                           [attr.max]="isGraduationYearField(field) ? null : getFieldMax(field)"
                                           [attr.step]="isGraduationYearField(field) ? null : getFieldStep(field)"
                                           [attr.maxlength]="isGraduationYearField(field) ? 4 : null"
                                           [attr.inputmode]="isGraduationYearField(field) ? 'numeric' : null"
                                           (input)="onGraduationYearInput($event, field)"
                                           (keydown)="isGraduationYearField(field) ? onGraduationYearKeydown($event) : null"
                                           [class.invalid]="bookingForm.get(field.id)?.invalid && bookingForm.get(field.id)?.touched">
                                    @if (bookingForm.get(field.id)?.invalid && bookingForm.get(field.id)?.touched) {
                                        <div class="error-message">
                                            @if (bookingForm.get(field.id)?.errors?.['required']) {
                                                <span>{{ field.label }} is required</span>
                                            } @else if (bookingForm.get(field.id)?.errors?.['noDecimals']) {
                                                <span>Please enter a valid year (digits only)</span>
                                            } @else if (bookingForm.get(field.id)?.errors?.['maxDigits']) {
                                                <span>Year must be 4 digits or less</span>
                                            } @else if (bookingForm.get(field.id)?.errors?.['min']) {
                                                <span>Value must be at least {{ getFieldMin(field) }}</span>
                                            } @else if (bookingForm.get(field.id)?.errors?.['max']) {
                                                <span>Value must be at most {{ getFieldMax(field) }}</span>
                                            } @else if (bookingForm.get(field.id)?.errors?.['pattern']) {
                                                <span>Please enter a valid number</span>
                                            }
                                        </div>
                                    }
                                }
                                @case ('tel') {
                                    <!-- Phone Number with Country Prefix -->
                                    <div class="phone-input-container">
                                        <div class="prefix-dropdown" (click)="togglePrefixDropdown($event)">
                                            <span class="selected-prefix">{{ selectedPrefix.flag }} {{ selectedPrefix.prefix }}</span>
                                            <span class="dropdown-arrow">▼</span>

                                            <div class="prefix-options" *ngIf="showPrefixDropdown">
                                                @for (prefix of prefixes; track prefix.prefix) {
                                                    <div class="prefix-option" (click)="selectPrefix(prefix, $event)">
                                                        <span class="prefix-flag">{{ prefix.flag }}</span>
                                                        <span class="prefix-country">{{ prefix.country }}</span>
                                                        <span class="prefix-code">{{ prefix.prefix }}</span>
                                                    </div>
                                                }
                                            </div>
                                        </div>

                                        <!-- Hidden form control for the prefix -->
                                        <input type="hidden" [formControlName]="field.id + 'Prefix'">

                                        <input type="tel" 
                                               [formControlName]="field.id" 
                                               [placeholder]="field.label"
                                               [class.invalid]="bookingForm.get(field.id)?.invalid && bookingForm.get(field.id)?.touched">
                                    </div>
                                    @if (bookingForm.get(field.id)?.invalid && bookingForm.get(field.id)?.touched) {
                                        <div class="error-message">
                                            @if (bookingForm.get(field.id)?.errors?.['required']) {
                                                <span>{{ field.label }} is required</span>
                                            } @else if (bookingForm.get(field.id)?.errors?.['pattern']) {
                                                <span>Please enter a valid phone number</span>
                                            }
                                        </div>
                                    }
                                }
                                @default {
                                    <input type="text" 
                                           [formControlName]="field.id" 
                                           [placeholder]="field.label"
                                           [class.invalid]="bookingForm.get(field.id)?.invalid && bookingForm.get(field.id)?.touched">
                                    @if (bookingForm.get(field.id)?.invalid && bookingForm.get(field.id)?.touched) {
                                        <div class="error-message">
                                            @if (bookingForm.get(field.id)?.errors?.['required']) {
                                                <span>{{ field.label }} is required</span>
                                            }
                                        </div>
                                    }
                                }
                            }
                        </div>
                    }
                    
                    <!-- Custom fields - shown only when lead creation is NOT enabled -->
                    @for (field of customFields; track field.id) {
                        <div class="form-group">
                            @switch (field.type) {
                                @case ('text') {
                                    <input type="text" 
                                           [formControlName]="field.id" 
                                           [placeholder]="field.label"
                                           [class.invalid]="bookingForm.get(field.id)?.invalid && bookingForm.get(field.id)?.touched">
                                    @if (bookingForm.get(field.id)?.invalid && bookingForm.get(field.id)?.touched) {
                                        <div class="error-message">
                                            @if (bookingForm.get(field.id)?.errors?.['required']) {
                                                <span>{{ field.label }} is required</span>
                                            }
                                        </div>
                                    }
                                }
                                @case ('email') {
                                    <input type="email" 
                                           [formControlName]="field.id" 
                                           [placeholder]="field.label"
                                           [class.invalid]="bookingForm.get(field.id)?.invalid && bookingForm.get(field.id)?.touched">
                                    @if (bookingForm.get(field.id)?.invalid && bookingForm.get(field.id)?.touched) {
                                        <div class="error-message">
                                            @if (bookingForm.get(field.id)?.errors?.['required']) {
                                                <span>{{ field.label }} is required</span>
                                            } @else if (bookingForm.get(field.id)?.errors?.['email']) {
                                                <span>Please enter a valid email address</span>
                                            }
                                        </div>
                                    }
                                }
                                @case ('textarea') {
                                    <textarea [formControlName]="field.id" 
                                              [placeholder]="field.label"
                                              [class.invalid]="bookingForm.get(field.id)?.invalid && bookingForm.get(field.id)?.touched"></textarea>
                                    @if (bookingForm.get(field.id)?.invalid && bookingForm.get(field.id)?.touched) {
                                        <div class="error-message">
                                            @if (bookingForm.get(field.id)?.errors?.['required']) {
                                                <span>{{ field.label }} is required</span>
                                            }
                                        </div>
                                    }
                                }
                                @case ('select') {
                                    <select [formControlName]="field.id"
                                            [class.invalid]="bookingForm.get(field.id)?.invalid && bookingForm.get(field.id)?.touched">
                                        <option value="" disabled selected>{{ field.label }}</option>
                                        @for (option of getFieldOptions(field); track option) {
                                            <option [value]="option">{{ option }}</option>
                                        }
                                    </select>
                                    @if (bookingForm.get(field.id)?.invalid && bookingForm.get(field.id)?.touched) {
                                        <div class="error-message">
                                            @if (bookingForm.get(field.id)?.errors?.['required']) {
                                                <span>{{ field.label }} is required</span>
                                            }
                                        </div>
                                    }
                                }
                                @case ('checkbox') {
                                    <div class="checkbox-container">
                                        <input type="checkbox" 
                                               [formControlName]="field.id" 
                                               [id]="'checkbox-' + field.id">
                                        <label [for]="'checkbox-' + field.id">{{ field.label }}</label>
                                    </div>
                                    @if (bookingForm.get(field.id)?.invalid && bookingForm.get(field.id)?.touched) {
                                        <div class="error-message">
                                            @if (bookingForm.get(field.id)?.errors?.['required']) {
                                                <span>This field is required</span>
                                            }
                                        </div>
                                    }
                                }
                                @case ('date') {
                                    <input type="date" 
                                           [formControlName]="field.id" 
                                           [placeholder]="field.label"
                                           [class.invalid]="bookingForm.get(field.id)?.invalid && bookingForm.get(field.id)?.touched">
                                    @if (bookingForm.get(field.id)?.invalid && bookingForm.get(field.id)?.touched) {
                                        <div class="error-message">
                                            @if (bookingForm.get(field.id)?.errors?.['required']) {
                                                <span>{{ field.label }} is required</span>
                                            } @else if (bookingForm.get(field.id)?.errors?.['dateMin']) {
                                                <span>Date must be today or later</span>
                                            } @else if (bookingForm.get(field.id)?.errors?.['dateMax']) {
                                                <span>Date must be before {{ field.maxDate }}</span>
                                            }
                                        </div>
                                    }
                                }
                                @case ('number') {
                                    <input [type]="isGraduationYearField(field) ? 'text' : 'number'"
                                           [formControlName]="field.id" 
                                           [placeholder]="field.label"
                                           [attr.min]="isGraduationYearField(field) ? null : getFieldMin(field)"
                                           [attr.max]="isGraduationYearField(field) ? null : getFieldMax(field)"
                                           [attr.step]="isGraduationYearField(field) ? null : getFieldStep(field)"
                                           [attr.maxlength]="isGraduationYearField(field) ? 4 : null"
                                           [attr.inputmode]="isGraduationYearField(field) ? 'numeric' : null"
                                           (input)="onGraduationYearInput($event, field)"
                                           (keydown)="isGraduationYearField(field) ? onGraduationYearKeydown($event) : null"
                                           [class.invalid]="bookingForm.get(field.id)?.invalid && bookingForm.get(field.id)?.touched">
                                    @if (bookingForm.get(field.id)?.invalid && bookingForm.get(field.id)?.touched) {
                                        <div class="error-message">
                                            @if (bookingForm.get(field.id)?.errors?.['required']) {
                                                <span>{{ field.label }} is required</span>
                                            } @else if (bookingForm.get(field.id)?.errors?.['noDecimals']) {
                                                <span>Please enter a valid year (digits only)</span>
                                            } @else if (bookingForm.get(field.id)?.errors?.['maxDigits']) {
                                                <span>Year must be 4 digits or less</span>
                                            } @else if (bookingForm.get(field.id)?.errors?.['min']) {
                                                <span>Value must be at least {{ getFieldMin(field) }}</span>
                                            } @else if (bookingForm.get(field.id)?.errors?.['max']) {
                                                <span>Value must be at most {{ getFieldMax(field) }}</span>
                                            } @else if (bookingForm.get(field.id)?.errors?.['pattern']) {
                                                <span>Please enter a valid number</span>
                                            }
                                        </div>
                                    }
                                }
                                @case ('tel') {
                                    <!-- Phone Number with Country Prefix -->
                                    <div class="phone-input-container">
                                        <div class="prefix-dropdown" (click)="togglePrefixDropdown($event)">
                                            <span class="selected-prefix">{{ selectedPrefix.flag }} {{ selectedPrefix.prefix }}</span>
                                            <span class="dropdown-arrow">▼</span>

                                            <div class="prefix-options" *ngIf="showPrefixDropdown">
                                                @for (prefix of prefixes; track prefix.prefix) {
                                                    <div class="prefix-option" (click)="selectPrefix(prefix, $event)">
                                                        <span class="prefix-flag">{{ prefix.flag }}</span>
                                                        <span class="prefix-country">{{ prefix.country }}</span>
                                                        <span class="prefix-code">{{ prefix.prefix }}</span>
                                                    </div>
                                                }
                                            </div>
                                        </div>

                                        <!-- Hidden form control for the prefix -->
                                        <input type="hidden" [formControlName]="field.id + 'Prefix'">

                                        <input type="tel" 
                                               [formControlName]="field.id" 
                                               [placeholder]="field.label"
                                               [class.invalid]="bookingForm.get(field.id)?.invalid && bookingForm.get(field.id)?.touched">
                                    </div>
                                    @if (bookingForm.get(field.id)?.invalid && bookingForm.get(field.id)?.touched) {
                                        <div class="error-message">
                                            @if (bookingForm.get(field.id)?.errors?.['required']) {
                                                <span>{{ field.label }} is required</span>
                                            } @else if (bookingForm.get(field.id)?.errors?.['pattern']) {
                                                <span>Please enter a valid phone number</span>
                                            }
                                        </div>
                                    }
                                }
                                @default {
                                    <input type="text" 
                                           [formControlName]="field.id" 
                                           [placeholder]="field.label"
                                           [class.invalid]="bookingForm.get(field.id)?.invalid && bookingForm.get(field.id)?.touched">
                                    @if (bookingForm.get(field.id)?.invalid && bookingForm.get(field.id)?.touched) {
                                        <div class="error-message">
                                            @if (bookingForm.get(field.id)?.errors?.['required']) {
                                                <span>{{ field.label }} is required</span>
                                            }
                                        </div>
                                    }
                                }
                            }
                        </div>
                    }
                }

                <!-- Lead fields - only shown when lead creation is enabled -->
                @if (isLeadCreationEnabled && leadFields.length > 0) {
                    <div class="lead-fields-section">
                        @for (field of leadFields; track field.id) {
                            <div class="form-group">
                                @switch (field.type) {
                                    @case ('text') {
                                        <input type="text" 
                                               [formControlName]="field.id" 
                                               [placeholder]="field.label"
                                               [class.invalid]="bookingForm.get(field.id)?.invalid && bookingForm.get(field.id)?.touched">
                                        @if (bookingForm.get(field.id)?.invalid && bookingForm.get(field.id)?.touched) {
                                            <div class="error-message">
                                                @if (bookingForm.get(field.id)?.errors?.['required']) {
                                                    <span>{{ field.label }} is required</span>
                                                }
                                            </div>
                                        }
                                    }
                                    @case ('email') {
                                        <input type="email" 
                                               [formControlName]="field.id" 
                                               [placeholder]="field.label"
                                               [class.invalid]="bookingForm.get(field.id)?.invalid && bookingForm.get(field.id)?.touched">
                                        @if (bookingForm.get(field.id)?.invalid && bookingForm.get(field.id)?.touched) {
                                            <div class="error-message">
                                                @if (bookingForm.get(field.id)?.errors?.['required']) {
                                                    <span>{{ field.label }} is required</span>
                                                } @else if (bookingForm.get(field.id)?.errors?.['email']) {
                                                    <span>Please enter a valid email address</span>
                                                }
                                            </div>
                                        }
                                    }
                                    @case ('textarea') {
                                        <textarea [formControlName]="field.id" 
                                                  [placeholder]="field.label"
                                                  [class.invalid]="bookingForm.get(field.id)?.invalid && bookingForm.get(field.id)?.touched"></textarea>
                                        @if (bookingForm.get(field.id)?.invalid && bookingForm.get(field.id)?.touched) {
                                            <div class="error-message">
                                                @if (bookingForm.get(field.id)?.errors?.['required']) {
                                                    <span>{{ field.label }} is required</span>
                                                }
                                            </div>
                                        }
                                    }
                                    @case ('select') {
                                        <select [formControlName]="field.id"
                                                [class.invalid]="bookingForm.get(field.id)?.invalid && bookingForm.get(field.id)?.touched">
                                            <option value="" disabled selected>{{ field.label }}</option>
                                            @for (option of getFieldOptions(field); track option) {
                                                <option [value]="option">{{ option }}</option>
                                            }
                                        </select>
                                        @if (bookingForm.get(field.id)?.invalid && bookingForm.get(field.id)?.touched) {
                                            <div class="error-message">
                                                @if (bookingForm.get(field.id)?.errors?.['required']) {
                                                    <span>{{ field.label }} is required</span>
                                                }
                                            </div>
                                        }
                                    }
                                    @case ('checkbox') {
                                        <div class="checkbox-container">
                                            <input type="checkbox" 
                                                   [formControlName]="field.id" 
                                                   [id]="'checkbox-' + field.id">
                                            <label [for]="'checkbox-' + field.id">{{ field.label }}</label>
                                        </div>
                                        @if (bookingForm.get(field.id)?.invalid && bookingForm.get(field.id)?.touched) {
                                            <div class="error-message">
                                                @if (bookingForm.get(field.id)?.errors?.['required']) {
                                                    <span>This field is required</span>
                                                }
                                            </div>
                                        }
                                    }
                                    @case ('date') {
                                        <input type="date" 
                                               [formControlName]="field.id" 
                                               [placeholder]="field.label"
                                               [class.invalid]="bookingForm.get(field.id)?.invalid && bookingForm.get(field.id)?.touched">
                                        @if (bookingForm.get(field.id)?.invalid && bookingForm.get(field.id)?.touched) {
                                            <div class="error-message">
                                                @if (bookingForm.get(field.id)?.errors?.['required']) {
                                                    <span>{{ field.label }} is required</span>
                                                } @else if (bookingForm.get(field.id)?.errors?.['dateMin']) {
                                                    <span>Date must be today or later</span>
                                                } @else if (bookingForm.get(field.id)?.errors?.['dateMax']) {
                                                    <span>Date must be before {{ field.maxDate }}</span>
                                                }
                                            </div>
                                        }
                                    }
                                    @case ('number') {
                                        <input [type]="isGraduationYearField(field) ? 'text' : 'number'"
                                               [formControlName]="field.id" 
                                               [placeholder]="field.label"
                                               [attr.min]="isGraduationYearField(field) ? null : getFieldMin(field)"
                                               [attr.max]="isGraduationYearField(field) ? null : getFieldMax(field)"
                                               [attr.step]="isGraduationYearField(field) ? null : getFieldStep(field)"
                                               [attr.maxlength]="isGraduationYearField(field) ? 4 : null"
                                               [attr.inputmode]="isGraduationYearField(field) ? 'numeric' : null"
                                               (input)="onGraduationYearInput($event, field)"
                                               (keydown)="isGraduationYearField(field) ? onGraduationYearKeydown($event) : null"
                                               [class.invalid]="bookingForm.get(field.id)?.invalid && bookingForm.get(field.id)?.touched">
                                        @if (bookingForm.get(field.id)?.invalid && bookingForm.get(field.id)?.touched) {
                                            <div class="error-message">
                                                @if (bookingForm.get(field.id)?.errors?.['required']) {
                                                    <span>{{ field.label }} is required</span>
                                                } @else if (bookingForm.get(field.id)?.errors?.['noDecimals']) {
                                                    <span>Please enter a valid year (digits only)</span>
                                                } @else if (bookingForm.get(field.id)?.errors?.['maxDigits']) {
                                                    <span>Year must be 4 digits or less</span>
                                                } @else if (bookingForm.get(field.id)?.errors?.['min']) {
                                                    <span>Value must be at least {{ getFieldMin(field) }}</span>
                                                } @else if (bookingForm.get(field.id)?.errors?.['max']) {
                                                    <span>Value must be at most {{ getFieldMax(field) }}</span>
                                                } @else if (bookingForm.get(field.id)?.errors?.['pattern']) {
                                                    <span>Please enter a valid number</span>
                                                }
                                            </div>
                                        }
                                    }
                                    @case ('tel') {
                                        <!-- Phone Number with Country Prefix -->
                                        <div class="phone-input-container">
                                            <div class="prefix-dropdown" (click)="togglePrefixDropdown($event)">
                                                <span class="selected-prefix">{{ selectedPrefix.flag }} {{ selectedPrefix.prefix }}</span>
                                                <span class="dropdown-arrow">▼</span>

                                                <div class="prefix-options" *ngIf="showPrefixDropdown">
                                                    @for (prefix of prefixes; track prefix.prefix) {
                                                        <div class="prefix-option" (click)="selectPrefix(prefix, $event)">
                                                            <span class="prefix-flag">{{ prefix.flag }}</span>
                                                            <span class="prefix-country">{{ prefix.country }}</span>
                                                            <span class="prefix-code">{{ prefix.prefix }}</span>
                                                        </div>
                                                    }
                                                </div>
                                            </div>

                                            <!-- Hidden form control for the prefix -->
                                            <input type="hidden" [formControlName]="field.id + 'Prefix'">

                                            <input type="tel" 
                                                   [formControlName]="field.id" 
                                                   [placeholder]="field.label"
                                                   [class.invalid]="bookingForm.get(field.id)?.invalid && bookingForm.get(field.id)?.touched">
                                        </div>
                                        @if (bookingForm.get(field.id)?.invalid && bookingForm.get(field.id)?.touched) {
                                            <div class="error-message">
                                                @if (bookingForm.get(field.id)?.errors?.['required']) {
                                                    <span>{{ field.label }} is required</span>
                                                } @else if (bookingForm.get(field.id)?.errors?.['pattern']) {
                                                    <span>Please enter a valid phone number</span>
                                                }
                                            </div>
                                        }
                                    }
                                    @default {
                                        <input type="text" 
                                               [formControlName]="field.id" 
                                               [placeholder]="field.label"
                                               [class.invalid]="bookingForm.get(field.id)?.invalid && bookingForm.get(field.id)?.touched">
                                        @if (bookingForm.get(field.id)?.invalid && bookingForm.get(field.id)?.touched) {
                                            <div class="error-message">
                                                @if (bookingForm.get(field.id)?.errors?.['required']) {
                                                    <span>{{ field.label }} is required</span>
                                                }
                                            </div>
                                        }
                                    }
                                }
                            </div>
                        }
                    </div>
                }
                
            </form>

            <div class="form-actions">
                <button type="button" [disabled]="disableButton" class="confirm-button" (click)="confirmBooking()">
                    Confirm booking
                </button>
            </div>
        </div>
        }
    </div>

    <div class="scheduler-footer">
        {{ meetingData?.footerText || meetingData?.companyName || 'Schedule meetings' }}
    </div>
    }
    @if(bookingComplete){
        <div class="thank-you-container">
            <div class="thank-you-card">
                <div class="success-icon">✓</div>
                <h1>Thank You for Booking!</h1>
                <p class="booking-confirmation">Your meeting has been successfully scheduled.</p>
                
                <div class="meeting-details">
                    <div class="detail-row">
                        <div class="detail-label">Meeting:</div>
                        <div class="detail-value">{{ meetingData.title }}</div>
                    </div>
                    <div class="detail-row">
                        <div class="detail-label">Date:</div>
                        <div class="detail-value">{{ formatDate(selectedTimeSlot.startTime) }}</div>
                    </div>
                    <div class="detail-row">
                        <div class="detail-label">Time:</div>
                        <div class="detail-value">{{ formatTime(selectedTimeSlot.startTime) }} - {{ formatTime(selectedTimeSlot.endTime) }}</div>
                    </div>
                    <div class="detail-row">
                        <div class="detail-label">Duration:</div>
                        <div class="detail-value">{{ getDurationText(selectedTimeSlot) }}</div>
                    </div>
                </div>
                
                <p class="calendar-notice">A calendar invitation has been sent to your email.</p>
            </div>
        </div>
    }
</div>

<!-- Show if meeting link is expired -->
<div *ngIf="meetingLinkExpired" class="expired-link-message">
    <h2>Meeting link has expired or is invalid</h2>
    <p>Please contact the organizer for a new meeting link.</p>
</div>